module.exports = __webpack_public_path__ + "static/sport/form-bg-1.e872e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/form-pc/form-bg-1.png
// module id = crsa
// module chunks = 0